module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('Card', {
    staticStyle: {
      "margin": "12px 0"
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" List Penyesuaian")]), _vm._v(" "), _c('div', {
    staticClass: "button-group",
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round",
      "size": "small"
    },
    on: {
      "click": _vm.showModalAdd
    }
  }, [_c('span', [_vm._v("Tambah")])]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round",
      "size": "small"
    },
    on: {
      "click": _vm.showModalAddEtc
    }
  }, [_c('span', [_vm._v("Tambah List")])]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success",
      "icon": "ios-search",
      "size": "small"
    },
    on: {
      "click": _vm.searchClickHandle
    }
  }, [_c('span', [_vm._v("Cari")])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.categoryId),
      callback: function($$v) {
        _vm.categoryId = $$v
      },
      expression: "categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.category))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Pembayaran")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.paymentDateSelect),
      callback: function($$v) {
        _vm.paymentDateSelect = $$v
      },
      expression: "paymentDateSelect"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getMarkingGroupByCode,
      "loading": _vm.isLoadingMarking
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionMarkingGroups), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingMarking),
      expression: "isLoadingMarking"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('Card', [_c('div', {
    staticClass: "table-container"
  }, [_c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "border": "",
      "columns": _vm.columnsDataTable,
      "data": _vm.paymentAdjustmentData
    }
  })], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%",
      "ok-text": "Cancel",
      "cancel-text": ""
    },
    on: {
      "on-ok": _vm.clearPaymentData
    },
    model: {
      value: (_vm.isModalAdd),
      callback: function($$v) {
        _vm.isModalAdd = $$v
      },
      expression: "isModalAdd"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Pembayaran Penyesuaian")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Format Kode NT"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.changeAdjustmentCategory()
      }
    },
    model: {
      value: (_vm.categoryId),
      callback: function($$v) {
        _vm.categoryId = $$v
      },
      expression: "categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(((category.category) + " - ( " + (category.code) + "XXX )")))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tgl Pembayaran"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "110px"
    },
    style: ({
      'pointer-events: none': _vm.categoryId == null
    }),
    attrs: {
      "type": "date",
      "placeholder": "",
      "format": "dd/MM/yyyy",
      "disabled": _vm.categoryId == null
    },
    model: {
      value: (_vm.paymentDate),
      callback: function($$v) {
        _vm.paymentDate = $$v
      },
      expression: "paymentDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [(_vm.searchSelectSubbranch == 'JKT') ? _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                              " + _vm._s(subbranch.subbranchname) + "\n                          ")])
  }), 1) : _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                              " + _vm._s(subbranch.subbranchname) + "\n                          ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.handleSwitchChange
    },
    model: {
      value: (_vm.isGroup),
      callback: function($$v) {
        _vm.isGroup = $$v
      },
      expression: "isGroup"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != null && _vm.isGroup == false),
      expression: "paymentDate != null && isGroup == false"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": _vm.getInvoiceData
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                              " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup == true),
      expression: "paymentDate != '' && isGroup == true"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "Ketik Group Name",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": _vm.getInvoiceDataByGroupMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                              " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1",
      "offset": "1"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetPayment),
      expression: "loadingGetPayment"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.depositRemaining != 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositRemaining != 0"
    }],
    attrs: {
      "label": "Total Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("currency")(_vm.depositRemaining)) + "\n                  ")]), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount > _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                      " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + " - LEBIH\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount <= _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                      Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositRemaining -
    _vm.totalUseDepositAmount))) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.depositMutasiRemaining),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining"
    }],
    attrs: {
      "label": "Total Mutasi Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("currency")(_vm.depositMutasiRemaining)) + "\n                  ")]), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi > _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                      " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + " - LEBIH\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                      Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositMutasiRemaining -
    _vm.totalUseDepositMutasi))) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.groupDepositRemaining != 0 && _vm.isGroup),
      expression: "paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup"
    }],
    attrs: {
      "label": 'Deposit ' + _vm.selectGroup
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.groupDepositRemaining)) + "\n                  ")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.amountReceived),
      callback: function($$v) {
        _vm.amountReceived = $$v
      },
      expression: "amountReceived"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountResidue != 0),
      expression: "amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                      Selisih   " + _vm._s(_vm._f("currency")(_vm.amountResidue)) + "\n                  ")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Pembulatan"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.creditRound),
      callback: function($$v) {
        _vm.creditRound = $$v
      },
      expression: "creditRound"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.creditRound > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && creditRound > 0"
    }],
    attrs: {
      "label": "Chart of Account"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.coaId),
      callback: function($$v) {
        _vm.coaId = $$v
      },
      expression: "coaId"
    }
  }, _vm._l((_vm.COAs), function(coa) {
    return _c('Option', {
      key: coa.id,
      attrs: {
        "value": coa.id
      }
    }, [_vm._v(_vm._s(coa.account_name))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId"
    }],
    attrs: {
      "label": "Uang Potongan"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.discountReceived),
      callback: function($$v) {
        _vm.discountReceived = $$v
      },
      expression: "discountReceived"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId == null),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId == null"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("    \n                  "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usernameAccess == 'susan' || _vm.usernameAccess == 'LINDA' || _vm.usernameAccess == 'fcl-sby' || _vm.usernameAccess == 'FONGFONG' || _vm.usernameAccess == 'MERRY' || _vm.usernameAccess == 'VIKA' || _vm.usernameAccess == 'ERIC' || _vm.usernameAccess == 'EVA-BKK' || _vm.usernameAccess == 'ADMIN-BKK' || _vm.usernameAccess == 'KENZA-BALI' || _vm.usernameAccess == 'ADRI' || _vm.usernameAccess == 'SYSTEM'),
      expression: "usernameAccess == 'susan' || usernameAccess == 'LINDA' || usernameAccess == 'fcl-sby' || usernameAccess == 'FONGFONG' || usernameAccess == 'MERRY' || usernameAccess == 'VIKA' || usernameAccess == 'ERIC' || usernameAccess == 'EVA-BKK' || usernameAccess == 'ADMIN-BKK' || usernameAccess == 'KENZA-BALI' || usernameAccess == 'ADRI' || usernameAccess == 'SYSTEM' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "discount",
      "value": "disc"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "disc")
    },
    on: {
      "change": function($event) {
        _vm.category = "disc"
      }
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usernameAccess == 'susan' || _vm.usernameAccess == 'LINDA' || _vm.usernameAccess == 'fcl-sby' || _vm.usernameAccess == 'FONGFONG' || _vm.usernameAccess == 'MERRY' || _vm.usernameAccess == 'VIKA' || _vm.usernameAccess == 'ERIC' || _vm.usernameAccess == 'EVA-BKK' || _vm.usernameAccess == 'ADMIN-BKK' || _vm.usernameAccess == 'KENZA-BALI' || _vm.usernameAccess == 'ADRI' || _vm.usernameAccess == 'SYSTEM'),
      expression: "usernameAccess == 'susan' || usernameAccess == 'LINDA' || usernameAccess == 'fcl-sby' || usernameAccess == 'FONGFONG' || usernameAccess == 'MERRY' || usernameAccess == 'VIKA' || usernameAccess == 'ERIC' || usernameAccess == 'EVA-BKK' || usernameAccess == 'ADMIN-BKK' || usernameAccess == 'KENZA-BALI' || usernameAccess == 'ADRI' || usernameAccess == 'SYSTEM' "
    }],
    attrs: {
      "for": "discount"
    }
  }, [_vm._v("Potongan")])]), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("    \n              ")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0),
      expression: "depositAmount != 0"
    }],
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Kelebihan :\n                  " + _vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0 && _vm.category == 'disc'),
      expression: "depositAmount != 0 && category == 'disc'"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("\n                  Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount > _vm.paymentPendingAmount && _vm.paymentPendingId),
      expression: "depositAmount > paymentPendingAmount && paymentPendingId"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v(" Tidak dapat melanjutkan proses pembayaran jika Alokasi Pembayaran lebih besar\n                  dari Mutasi.")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.groupDepositRemaining != 0 && _vm.isGroup),
      expression: "paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup"
    }]
  }, [_vm._v("\n                  Total Alokasi Marking " + _vm._s(_vm.selectGroup) + " : " + _vm._s(_vm._f("currency")(_vm.totalAmountSelect)) + "\n              ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.invoiceDues.length > 0 && _vm.receivableGroup == ''),
      expression: "this.invoiceDues.length > 0 && receivableGroup == ''"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Daftar Invoices ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg ivu-row-flex-space-between",
    attrs: {
      "type": "flex"
    }
  }, [
    [_c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v(" Tgl Bongkar ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v(" Potongan ")])]
  ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.paymentMarking.includes('SBR/') || _vm.paymentMarking.includes('SBRT/') || _vm.paymentMarking.includes('CTH/')) ? _c('div', _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePaymentDecimal', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentPendingId": _vm.paymentPendingId,
        "paymentPendingAmount": _vm.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  }), 0) : _c('div', _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePayment', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentPendingId": _vm.paymentPendingId,
        "paymentPendingAmount": _vm.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  }), 0)])], 1), _vm._v(" "), (_vm.receivableGroup != '') ? _c('Card', [_c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.groupClickHandle
    }
  }, _vm._l((_vm.receivableGroup), function(marking) {
    return _c('TabPane', {
      key: marking.markingheadercode,
      attrs: {
        "label": marking.markingheadercode
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" Daftar Invoice ")]), _vm._v(" "), _c('Row', {
      staticClass: "code-row-bg",
      attrs: {
        "type": "flex"
      }
    }, [
      [_c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v(" Tgl Bongkar")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "5"
        }
      }, [_vm._v(" Potongan ")])]
    ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((marking.invoiceDue), function(invoiceDue) {
      return _c('div', {
        key: invoiceDue.id
      }, [_c('cInvoicePayment', {
        attrs: {
          "invoiceDue": invoiceDue,
          "depositRemaining": _vm.depositRemaining,
          "depositMutasiRemaining": _vm.depositMutasiRemaining,
          "paymentPendingId": _vm.paymentPendingId,
          "paymentPendingAmount": _vm.paymentPendingAmount
        },
        on: {
          "setAllocateAmount": _vm.setAllocateAmount
        }
      }), _vm._v(" "), _c('br')], 1)
    })], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false),
      expression: "isGroup == false"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) || ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) && _vm.paymentPendingId == null && (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) || ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && paymentPendingId == null && (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost && (_vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0)) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) || ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) && (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) || ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        _vm.depositType = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDeposit),
      callback: function($$v) {
        _vm.modalConfirmDeposit = $$v
      },
      expression: "modalConfirmDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v("\n          Kelebihan "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" akan dijadikan sebagai :\n          "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.depositType),
      callback: function($$v) {
        _vm.depositType = $$v
      },
      expression: "depositType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "DEP"
    }
  }, [_c('span', [_vm._v("Deposit")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "PRF"
    }
  }, [_c('span', [_vm._v("Pendapatan")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.paymentPendingId == null),
      expression: "isGroup == false && paymentPendingId == null"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%",
      "ok-text": "Cancel",
      "cancel-text": ""
    },
    on: {
      "on-ok": _vm.clearPaymentData
    },
    model: {
      value: (_vm.isModalAddList),
      callback: function($$v) {
        _vm.isModalAddList = $$v
      },
      expression: "isModalAddList"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Proses Pembayaran")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Format Kode NT"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "Select",
      "disabled": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.changeAdjustmentCategory()
      }
    },
    model: {
      value: (_vm.categoryId),
      callback: function($$v) {
        _vm.categoryId = $$v
      },
      expression: "categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(((category.category) + " - ( " + (category.code) + "XXX )")))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Kode NT"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.note_code),
      callback: function($$v) {
        _vm.note_code = $$v
      },
      expression: "note_code"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tgl Pembayaran"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "110px"
    },
    style: ({
      'pointer-events: none': _vm.categoryId == null
    }),
    attrs: {
      "type": "date",
      "placeholder": "",
      "format": "dd/MM/yyyy",
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.paymentDate),
      callback: function($$v) {
        _vm.paymentDate = $$v
      },
      expression: "paymentDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [(_vm.searchSelectSubbranch == 'JKT') ? _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                              " + _vm._s(subbranch.subbranchname) + "\n                          ")])
  }), 1) : _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                              " + _vm._s(subbranch.subbranchname) + "\n                          ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != null && _vm.isGroup == false),
      expression: "paymentDate != null && isGroup == false"
    }],
    attrs: {
      "span": "2"
    }
  }, [_c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.markingCode),
      callback: function($$v) {
        _vm.markingCode = $$v
      },
      expression: "markingCode"
    }
  })], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup == true),
      expression: "paymentDate != '' && isGroup == true"
    }],
    attrs: {
      "span": "2"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Marking Group")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.markingGroupCode),
      callback: function($$v) {
        _vm.markingGroupCode = $$v
      },
      expression: "markingGroupCode"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3",
      "offset": "3"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetPayment),
      expression: "loadingGetPayment"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "360px"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.depositRemaining != 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositRemaining != 0"
    }],
    attrs: {
      "label": "Total Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("currency")(_vm.depositRemaining)) + "\n                  ")]), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount > _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                      " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + " - LEBIH\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount <= _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                      Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositRemaining -
    _vm.totalUseDepositAmount))) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.depositMutasiRemaining),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining"
    }],
    attrs: {
      "label": "Total Mutasi Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("currency")(_vm.depositMutasiRemaining)) + "\n                  ")]), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi > _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                      " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + " - LEBIH\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                      Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositMutasiRemaining -
    _vm.totalUseDepositMutasi))) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.groupDepositRemaining != 0 && _vm.isGroup),
      expression: "paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup"
    }],
    attrs: {
      "label": 'Deposit ' + _vm.selectGroup
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.groupDepositRemaining)) + "\n                  ")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.amountReceived),
      callback: function($$v) {
        _vm.amountReceived = $$v
      },
      expression: "amountReceived"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountResidue != 0),
      expression: "amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                      Selisih   " + _vm._s(_vm._f("currency")(_vm.amountResidue)) + "\n                  ")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0"
    }],
    attrs: {
      "label": "Pembulatan"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.creditRound),
      callback: function($$v) {
        _vm.creditRound = $$v
      },
      expression: "creditRound"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.creditRound > 0),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && creditRound > 0"
    }],
    attrs: {
      "label": "Chart of Account"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.coaId),
      callback: function($$v) {
        _vm.coaId = $$v
      },
      expression: "coaId"
    }
  }, _vm._l((_vm.COAs), function(coa) {
    return _c('Option', {
      key: coa.id,
      attrs: {
        "value": coa.id
      }
    }, [_vm._v(_vm._s(coa.account_name))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId"
    }],
    attrs: {
      "label": "Uang Potongan"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.discountReceived),
      callback: function($$v) {
        _vm.discountReceived = $$v
      },
      expression: "discountReceived"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId == null),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId == null"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("    \n                  "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usernameAccess == 'susan' || _vm.usernameAccess == 'LINDA' || _vm.usernameAccess == 'fcl-sby' || _vm.usernameAccess == 'FONGFONG' || _vm.usernameAccess == 'MERRY' || _vm.usernameAccess == 'VIKA' || _vm.usernameAccess == 'ERIC' || _vm.usernameAccess == 'EVA-BKK' || _vm.usernameAccess == 'ADMIN-BKK' || _vm.usernameAccess == 'KENZA-BALI' || _vm.usernameAccess == 'ADRI' || _vm.usernameAccess == 'SYSTEM'),
      expression: "usernameAccess == 'susan' || usernameAccess == 'LINDA' || usernameAccess == 'fcl-sby' || usernameAccess == 'FONGFONG' || usernameAccess == 'MERRY' || usernameAccess == 'VIKA' || usernameAccess == 'ERIC' || usernameAccess == 'EVA-BKK' || usernameAccess == 'ADMIN-BKK' || usernameAccess == 'KENZA-BALI' || usernameAccess == 'ADRI' || usernameAccess == 'SYSTEM' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "discount",
      "value": "disc"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "disc")
    },
    on: {
      "change": function($event) {
        _vm.category = "disc"
      }
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usernameAccess == 'susan' || _vm.usernameAccess == 'LINDA' || _vm.usernameAccess == 'fcl-sby' || _vm.usernameAccess == 'FONGFONG' || _vm.usernameAccess == 'MERRY' || _vm.usernameAccess == 'VIKA' || _vm.usernameAccess == 'ERIC' || _vm.usernameAccess == 'EVA-BKK' || _vm.usernameAccess == 'ADMIN-BKK' || _vm.usernameAccess == 'KENZA-BALI' || _vm.usernameAccess == 'ADRI' || _vm.usernameAccess == 'SYSTEM'),
      expression: "usernameAccess == 'susan' || usernameAccess == 'LINDA' || usernameAccess == 'fcl-sby' || usernameAccess == 'FONGFONG' || usernameAccess == 'MERRY' || usernameAccess == 'VIKA' || usernameAccess == 'ERIC' || usernameAccess == 'EVA-BKK' || usernameAccess == 'ADMIN-BKK' || usernameAccess == 'KENZA-BALI' || usernameAccess == 'ADRI' || usernameAccess == 'SYSTEM' "
    }],
    attrs: {
      "for": "discount"
    }
  }, [_vm._v("Potongan")])]), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentPendingId),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("    \n              ")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0),
      expression: "depositAmount != 0"
    }],
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Kelebihan :\n                  " + _vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0 && _vm.category == 'disc'),
      expression: "depositAmount != 0 && category == 'disc'"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("\n                  Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount > _vm.paymentPendingAmount && _vm.paymentPendingId),
      expression: "depositAmount > paymentPendingAmount && paymentPendingId"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v(" Tidak dapat melanjutkan proses pembayaran jika Alokasi Pembayaran lebih besar\n                  dari Mutasi.")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.groupDepositRemaining != 0 && _vm.isGroup),
      expression: "paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup"
    }]
  }, [_vm._v("\n                  Total Alokasi Marking " + _vm._s(_vm.selectGroup) + " : " + _vm._s(_vm._f("currency")(_vm.totalAmountSelect)) + "\n              ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.invoiceDues.length > 0 && _vm.receivableGroup == ''),
      expression: "this.invoiceDues.length > 0 && receivableGroup == ''"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Daftar Invoices ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg ivu-row-flex-space-between",
    attrs: {
      "type": "flex"
    }
  }, [
    [_c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v(" Tgl Bongkar ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v(" Potongan ")])]
  ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.paymentMarking.includes('SBR/') || _vm.paymentMarking.includes('SBRT/') || _vm.paymentMarking.includes('CTH/')) ? _c('div', _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePaymentDecimal', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentPendingId": _vm.paymentPendingId,
        "paymentPendingAmount": _vm.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  }), 0) : _c('div', _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePayment', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentPendingId": _vm.paymentPendingId,
        "paymentPendingAmount": _vm.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  }), 0)])], 1), _vm._v(" "), (_vm.receivableGroup != '') ? _c('Card', [_c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.groupClickHandle
    }
  }, _vm._l((_vm.receivableGroup), function(marking) {
    return _c('TabPane', {
      key: marking.markingheadercode,
      attrs: {
        "label": marking.markingheadercode
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" Daftar Invoice ")]), _vm._v(" "), _c('Row', {
      staticClass: "code-row-bg",
      attrs: {
        "type": "flex"
      }
    }, [
      [_c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v(" Tgl Bongkar")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "5"
        }
      }, [_vm._v(" Potongan ")])]
    ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((marking.invoiceDue), function(invoiceDue) {
      return _c('div', {
        key: invoiceDue.id
      }, [_c('cInvoicePayment', {
        attrs: {
          "invoiceDue": invoiceDue,
          "depositRemaining": _vm.depositRemaining,
          "depositMutasiRemaining": _vm.depositMutasiRemaining,
          "paymentPendingId": _vm.paymentPendingId,
          "paymentPendingAmount": _vm.paymentPendingAmount
        },
        on: {
          "setAllocateAmount": _vm.setAllocateAmount
        }
      }), _vm._v(" "), _c('br')], 1)
    })], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false),
      expression: "isGroup == false"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) || ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) && _vm.paymentPendingId == null && (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) || ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && paymentPendingId == null && (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost && (_vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0)) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) || ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) && (_vm.creditRound == 0 || _vm.creditRound > 0 && _vm.coaId != null)),
      expression: "description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) || ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && (creditRound == 0 || creditRound > 0 && coaId != null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        _vm.depositType = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDeposit),
      callback: function($$v) {
        _vm.modalConfirmDeposit = $$v
      },
      expression: "modalConfirmDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v("\n          Kelebihan "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" akan dijadikan sebagai :\n          "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.depositType),
      callback: function($$v) {
        _vm.depositType = $$v
      },
      expression: "depositType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "DEP"
    }
  }, [_c('span', [_vm._v("Deposit")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "PRF"
    }
  }, [_c('span', [_vm._v("Pendapatan")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.paymentPendingId == null),
      expression: "isGroup == false && paymentPendingId == null"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "30%"
    },
    model: {
      value: (_vm.isModalAddEtc),
      callback: function($$v) {
        _vm.isModalAddEtc = $$v
      },
      expression: "isModalAddEtc"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Create Adjustment Data")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAdd",
    attrs: {
      "model": _vm.formAdd,
      "label-position": "top"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Format Kode NT",
      "prop": "categoryId"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.changeAdjustmentCategory()
      }
    },
    model: {
      value: (_vm.categoryId),
      callback: function($$v) {
        _vm.categoryId = $$v
      },
      expression: "categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(((category.category) + " - ( " + (category.code) + "XXX )")))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Marking",
      "prop": "marking"
    }
  }, [_c('Col', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getMarkingGroupByCode,
      "loading": _vm.isLoadingMarking
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionMarkingGroups), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "paymentDate"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "10px",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin-bottom": "4px"
    }
  }, [_vm._v("\n                  Tanggal Pembayaran\n                ")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Pilih Tanggal Pembayaran",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.paymentDate),
      callback: function($$v) {
        _vm.paymentDate = $$v
      },
      expression: "paymentDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin-bottom": "4px"
    }
  }, [_vm._v("\n                  Nominal Pembayaran\n                ")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }, 'money', _vm.money, false))], 1)])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Deskripsi"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "loading": _vm.isLoadingMarking
    },
    on: {
      "click": _vm.clearPaymentData
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingMarking
    },
    on: {
      "click": _vm.postAddAdjustment
    }
  }, [_c('span', [_vm._v("Submit")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "30%"
    },
    on: {
      "on-cancel": _vm.clearPaymentData
    },
    model: {
      value: (_vm.isModalEditEtc),
      callback: function($$v) {
        _vm.isModalEditEtc = $$v
      },
      expression: "isModalEditEtc"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Adjustment Data")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAdd",
    attrs: {
      "model": _vm.formAdd,
      "label-position": "top"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Format Kode NT",
      "prop": "categoryId"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.changeAdjustmentCategory()
      }
    },
    model: {
      value: (_vm.categoryId),
      callback: function($$v) {
        _vm.categoryId = $$v
      },
      expression: "categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(((category.category) + " - ( " + (category.code) + "XXX )")))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Marking",
      "prop": "marking"
    }
  }, [_c('Col', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getMarkingGroupByCode,
      "loading": _vm.isLoadingMarking
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionMarkingGroups), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "paymentDate"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "10px",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin-bottom": "4px"
    }
  }, [_vm._v("\n                  Tanggal Pembayaran\n                ")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Pilih Tanggal Pembayaran",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.paymentDate),
      callback: function($$v) {
        _vm.paymentDate = $$v
      },
      expression: "paymentDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin-bottom": "4px"
    }
  }, [_vm._v("\n                  Nominal Pembayaran\n                ")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }, 'money', _vm.money, false))], 1)])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Deskripsi"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "loading": _vm.isLoadingMarking
    },
    on: {
      "click": _vm.clearPaymentData
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingMarking
    },
    on: {
      "click": _vm.postAddAdjustment
    }
  }, [_c('span', [_vm._v("Edit")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi",
      "ok-text": "Yes",
      "cancel-text": "No"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescription = ''
      }
    },
    model: {
      value: (_vm.isModalDelete),
      callback: function($$v) {
        _vm.isModalDelete = $$v
      },
      expression: "isModalDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Delete List Data")])], 1), _vm._v(" "), [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" Marking")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" : ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" " + _vm._s(this.formDelete.marking) + " " + _vm._s(this.formDelete.markinggroup) + " ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" Amount ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" : ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" " + _vm._s(this.formDelete.amount) + " ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" Note Code ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" : ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" " + _vm._s(this.formDelete.note_code) + " ")])], 1)], 1), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.formDelete.note_code))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (this.formDelete.id),
      callback: function($$v) {
        _vm.$set(this.formDelete, "id", $$v)
      },
      expression: "this.formDelete.id"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formDelete.note_code == _vm.confirmDescription),
      expression: "formDelete.note_code == confirmDescription"
    }],
    attrs: {
      "type": "error",
      "long": ""
    }
  }, [_vm._v("Delete")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-675dddf5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentAdjustment.vue
// module id = 1821
// module chunks = 1